import { BASE_URL } from '@~/constants/api';

import actions from './index';

export const ACTIONS = {
  GET: 'GET_PTM_SCHEDULED_DATE',
  GET_SUCCESS: 'GET_PTM_SCHEDULED_DATE_SUCCESS',
  GET_FAILURE: 'GET_PTM_SCHEDULED_DATE_FAILURE',
};

export const get = actions.get(
  studentId => `${BASE_URL}/ptm/student/${studentId}/classroom/`,
  {
    PENDING: ACTIONS.GET,
    SUCCESS: ACTIONS.GET_SUCCESS,
    FAILURE: ACTIONS.GET_FAILURE,
  },
);
